import store2 from 'store2';

/**
 * @param {string} namespaces The namespace used to localstorage, ('generic') is default value.
 * @returns {store2} The function refer to https://www.npmjs.com/package/store2.
 */

const storeHelper = (namespace = 'generic') => store2.namespace(namespace);

export default storeHelper;
